import React from 'react';
import MaterialSelect from './materialSelect';
import localization from '../helpers/localization.js';

const StoveSelectionComponent = ({ stoveChanged, stoves, selectedStove, showPrices, prices, stoveDescription, showDescription,showRemoveStoveBtn, descriptionChanged }) =>
  {
  var stovesWithThumbnails = stoves.map(stove=>{return Object.assign({thumbnail:stove.image},stove);});
    return (<div>
        <MaterialSelect autoAdjustWidth={true} materials={stovesWithThumbnails} onChange={stoveChanged} selected={selectedStove} header={localization.stove} showPrices={showPrices} prices={prices} />
        {removeStoveBtn(showRemoveStoveBtn, stoveChanged)}
        {descriptionControl(showDescription, stoveDescription, descriptionChanged)}
        </div>)
  }
export default StoveSelectionComponent


let descriptionControl = (showDescription, stoveDescription,descriptionChanged) => {
    if (showDescription) {
        return < div><label htmlFor="stoveDescription"  >Kiukaan merkki/malli</label><input type="text" onChange={(event) => descriptionChanged(event.target.value)} value={stoveDescription} id="stoveDescription"></input></div >
    }
    else {
        return "";
    }
}
let removeStoveBtn = (showRemoveStoveBtn, stoveChanged) => {
    if (showRemoveStoveBtn) {
        return <div className="orangeButton">
            <span className="buttonTxt" onClick={() => stoveChanged("ownStove")} >Ei kiuasta/Hankin kiukaan itse.</span>
        </div>
    }
    else
        return "";

}